/**
 * Z-Index design tokens.
 *
 * For use with the following CSS properties:
 *
 *     z-index
 *
 * @see https://system-ui.com/theme
 */
export const zIndex = [-1, 1, 50, 100, 1000, 9999] as const
